/* src/app/workshop/partials/defect-form/defect-form.component.scss */
select option:disabled {
  color: red;
  font-weight: lighter;
  font-style: italic;
}
/*# sourceMappingURL=defect-form.component.css.map */
